export const Role = {
  Admin: 'admin',
  Operator: 'operator',
  User: 'user'
}